import React, { Fragment } from 'react';
import { Column, Section, Title, Container, Card} from "rbx";
import "../../../styles/auth.scss";
import Header from "../../../components/components/Header";
import LoginForm from '../../../components/auth/login_form';

const LoginScreen = () => {

  return (
    <Fragment>
      <Header/>
      <Section size="small" className="auth">
        <Container>
          <Column.Group centered>
            <Column size={4}>
              <Card>
                <Card.Content>
                  <Section>
                    <Column.Group>
                      <Column size={12}>
                        <Title size={4} className="has-text-centered">
                          Autentique-se para continuar!
                        </Title>
                        <LoginForm />
                      </Column>
                    </Column.Group>
                  </Section>
                </Card.Content>
              </Card>
            </Column>
          </Column.Group>
        </Container>
      </Section>
    </Fragment>
  )

}

export default LoginScreen;
